const TV_DEBUG_FLAG = 'tellus_debug_tv'

const isDev =
  typeof __DEV__ !== 'undefined'
    ? __DEV__
    : process.env.NODE_ENV !== 'production'

function readLocalStorageFlag() {
  if (typeof window === 'undefined' || !window.localStorage) return false
  try {
    return window.localStorage.getItem(TV_DEBUG_FLAG) === '1'
  } catch {
    return false
  }
}

export function isTellusTvDebugEnabled() {
  if (!isDev) return false
  return readLocalStorageFlag()
}

export function tellusTvDebug(event: string, payload?: unknown) {
  if (!isTellusTvDebugEnabled()) return
  if (payload !== undefined) {
    console.debug(`[TellusTV] ${event}`, payload)
  } else {
    console.debug(`[TellusTV] ${event}`)
  }
}
